import { createZodDto } from "nestjs-zod/dto";
import { z } from "zod";

export const ONBOARDING_STEPS = ["welcome", "import", "profile", "targets", "ready"] as const;

export const patchOnboardingProgressSchema = z.object({
  step: z.enum(ONBOARDING_STEPS),
  data: z.record(z.unknown()),
});

export const postOnboardingSchema = z.object({
  data: z.record(z.unknown()),
});

export const getOnboardingProgressResponseSchema = patchOnboardingProgressSchema;

export class PatchOnboardingProgressDto extends createZodDto(patchOnboardingProgressSchema) {}

export class PostOnboardingDto extends createZodDto(postOnboardingSchema) {}

export class GetOnboardingProgressResponseDto extends createZodDto(
  getOnboardingProgressResponseSchema,
) {}
